import { ReactComponent as MinusDelete } from "assets/icons/PendingIcon.svg";
import React from 'react';
import { useHistory } from "react-router";
import { RelatedContactsItem, RelatedContactsItemDelete, RelatedContactsItemLink, RelatedContactsItemText, RelatedContactsItemTextStrong, RelatedContactsList } from './Theme';

const RelatedContacts = ({
  list,
  onDeleteRelatedContact
}) => {
  const history = useHistory();  
  return (
    <RelatedContactsList>
      {list?.length > 0 ? list.map((item, index) => (
        <RelatedContactsItem>
          <RelatedContactsItemText>
            <RelatedContactsItemTextStrong>{item?.relationship?.label}</RelatedContactsItemTextStrong> of
            <RelatedContactsItemLink
              onClick={() => {
                history.push(`/member-details/${item?.contact?.account_id}?q=${item?.contact?.value}&tab=Family`);
              }}
            >{item?.contact?.label}</RelatedContactsItemLink>
          </RelatedContactsItemText>
          <RelatedContactsItemDelete
            onClick={() => {
              onDeleteRelatedContact(index)
            }}
          >

            <MinusDelete />
          </RelatedContactsItemDelete>
        </RelatedContactsItem>
      )) : (
        <div>No related contacts</div>
      )}
    </RelatedContactsList>
  )
}

export default RelatedContacts